import Card from '@/components/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

interface colorProps {
  color: string;
}

export const GradientText = styled(Typography)<colorProps>`
  ${({ color }) => {
    const colorFade = 'rgb(255,255,255,0.95)';
    const currentGradient = `linear-gradient(30deg, ${color}, ${color}, ${colorFade})`;
    return `
      background-image: ${currentGradient};
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
    `;
  }}
`;

export const InfoCardRow = styled(Card)`
  max-width: 100%;
  transition: all 0.2s ease-in-out;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows[4]};
    border-color: ${({ theme }) => theme.palette.divider};
  }
`;

export const InfoNameStack = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const InfoStack = styled(Stack)`
  flex-direction: row;
  align-items: flex-end;
  gap: 4px;
  margin-top: 8px;
`;
